<input [multiple]="multiple" [accept]="allowedTypes" type="file" #nativeInput [id]="id" (change)="onChange($event)" />
<span [attr.data-placeholder]="placeholder">{{ fileName }}</span>
<button *ngIf="internalValue" type="button" class="clear-btn" (click)="onClear()"></button>
<label [for]="id" class="btn" tabindex="0">{{ 'common.select.file' | i18next }}</label>
